/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {
  Page
} from '@/types/pages';

// input selectors ...
const selectPages = ({nav}) => nav.pages;
const selectSelectedIndex = ({nav}) => nav.selectedIndex;
const selectCurrentPage = ({nav}) => nav.currentPage;
const selectIsUserProfileView = ({nav}) => nav.isUserProfileView;

// output selectors ...
export const pagesSelector = createDeepEqualSelector(selectPages,
  (pages: Page[]): Page[] => pages
);

export const selectedIndexSelector = createSelector(selectSelectedIndex,
  (selectedIndex: number): number => selectedIndex
);

export const currentPageSelector = createSelector(selectCurrentPage,
  (currentPage: string): string => currentPage
);

export const isUserProfileViewSelector = createSelector(selectIsUserProfileView,
  (isUserProfileView: boolean): boolean => isUserProfileView
);
